import { render } from "./InputFrequency.vue?vue&type=template&id=0242c518"
import script from "./InputFrequency.vue?vue&type=script&lang=js"
export * from "./InputFrequency.vue?vue&type=script&lang=js"
script.render = render

export default script